/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OsrmBaseApiResponse
 */
export interface OsrmBaseApiResponse {
  /**
   *
   * @type {string}
   * @memberof OsrmBaseApiResponse
   */
  code: OsrmBaseApiResponseCodeEnum;
  /**
   *
   * @type {string}
   * @memberof OsrmBaseApiResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof OsrmBaseApiResponse
   */
  dataVersion?: string;
}

/**
 * @export
 */
export const OsrmBaseApiResponseCodeEnum = {
  Ok: "Ok",
  InvalidUrl: "InvalidUrl",
  InvalidService: "InvalidService",
  InvalidVersion: "InvalidVersion",
  InvalidOptions: "InvalidOptions",
  InvalidQuery: "InvalidQuery",
  InvalidValue: "InvalidValue",
  NoSegment: "NoSegment",
  TooBig: "TooBig",
  NoRoute: "NoRoute",
  NoTable: "NoTable",
  NotImplemented: "NotImplemented",
  NoTrips: "NoTrips",
} as const;
export type OsrmBaseApiResponseCodeEnum =
  (typeof OsrmBaseApiResponseCodeEnum)[keyof typeof OsrmBaseApiResponseCodeEnum];

/**
 * Check if a given object implements the OsrmBaseApiResponse interface.
 */
export function instanceOfOsrmBaseApiResponse(
  value: object,
): value is OsrmBaseApiResponse {
  if (!("code" in value) || value["code"] === undefined) return false;
  return true;
}

export function OsrmBaseApiResponseFromJSON(json: any): OsrmBaseApiResponse {
  return OsrmBaseApiResponseFromJSONTyped(json, false);
}

export function OsrmBaseApiResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OsrmBaseApiResponse {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    message: json["message"] == null ? undefined : json["message"],
    dataVersion:
      json["data_version"] == null ? undefined : json["data_version"],
  };
}

export function OsrmBaseApiResponseToJSON(json: any): OsrmBaseApiResponse {
  return OsrmBaseApiResponseToJSONTyped(json, false);
}

export function OsrmBaseApiResponseToJSONTyped(
  value?: OsrmBaseApiResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    code: value["code"],
    message: value["message"],
    data_version: value["dataVersion"],
  };
}
